export { AcademyHeaderWrapper as DocsHeaderWrapper } from '../AcademyHeaderWrapper'
